import React from 'react'
import Form from '../../../components/Form'
import fields, { UserEditFormData } from './fields'
import { toast } from 'react-toastify'
import { handleFormSubmit, useRequest } from '@polvo-labs/react-auth'
import { useHistory } from 'react-router-dom'
import routes from '../../../config/routes'
import UserType from '../../../models/User'

interface Props {
  user: UserType
}

const UserEditForm: React.FC<Props> = ({ user }) => {
  const { request } = useRequest()
  const history = useHistory()

  return (
    <Form<UserEditFormData>
      buttonLabel="SALVAR"
      fields={fields}
      initialValues={user as UserEditFormData}
      onSubmit={data => handleFormSubmit({
        request: request({
          method: 'PUT',
          url: `${process.env.REACT_APP_API_URL}/users/${user.id}`,
          data,
        }),
        onValidationErrors: () => toast.error('Erros de validacao.'),
        onSuccess: ({ data }) => {
          toast.success('Usuário cadastrado com sucesso.')
          history.push(routes.admin.user.index.path)
        },
        onFailure: () => toast.error('Erro ao alterar informações.'),
      })}
    />
  )
}

export default UserEditForm
